<template>
  <!-- Page -->
  <sui-page>
    <!-- Page Header -->
    <sui-page-header title="Select Box" />
    <!-- Page Contents -->
    <sui-page-contents>
      <!-- 차수 이동 Select Box [S] -->
      <div slot="top">
        <cmp-order-select
          v-model="orderSelectSelectedItem"
          :option-list="orderSelectOptionList"
          is-simple
          @list-click="onClickOrderSelectItem"
        />
        <span class="info caution">{{ orderSelectSelectedItem }}</span>
      </div>
      <!-- 차수 이동 Select Box [E] -->

      <div class="comm_title_wrap">
        <span class="-fdp-input-label__star">
          <h4>빨강 글씨</h4>
        </span>
        <div class="comm_line_div" />
        <div class="info">
          v-model 값입니다.
        </div>
      </div>

      <!-- Multi Select -->
      <div class="comm_ptitle_wrap">
        <h1>Multi Select (below)</h1>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-2">
            <sui-label label="<multi-select>" />
          </div>
          <div class="col-xs-4">
            <sui-multi-select
              ref="multiSelect"
              v-model="multiSelectValue"
              :options="multiSelectOptions"
              :multiple="true"
              :closeOnSelect="false"
              :useAllOption="true"
              @select="onAfterSelecting"
              @confirm="onConfirm"
            />
          </div>
          <div class="col-xs-6">
            <div class="info">
              multi
            </div>
            <div class="comm_line_div" />
            <span class="info caution">{{ multiSelectValue }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-2">
            <sui-label label="<multi-select>" />
          </div>
          <div class="col-xs-4">
            <sui-multi-select
              ref="multiSelect1"
              v-model="multiSelectValue"
              :options="multiSelectOptions"
              @select="onAfterSelecting"
            />
          </div>
          <div class="col-xs-6">
            <div class="info">
              single
            </div>
            <div class="comm_line_div" />
            <span class="info caution">{{ multiSelectValue }}</span>
          </div>
        </div>
      </div>

      <!-- Single Select -->
      <div class="comm_ptitle_wrap">
        <h1>Single Select</h1>
      </div>
      <div class="row">
        <div class="col-xs-2">
          <sui-input-label label="<moudle-submodule-select>" />
        </div>
        <div class="col-xs-4">
          <sui-module-submodule-select
            :selectedMd="selected.md"
            :selectedSmd="selected.smd"
            :defaultMdOption="'select'"
            :defaultSmdOption="'all'"
          />
        </div>
        <div class="col-xs-6">
          <span class="info caution">{{ selected.md }}</span>
          <div class="comm_line_div" />
          <span class="info caution">{{ selected.smd }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-2">
          <sui-input-label label="초기 선택값 지정" />
        </div>
        <div class="col-xs-4">
          <sui-module-submodule-select
            :selectedMd="selected.md2"
            :selectedSmd="selected.smd2"
            :initialSelectedMdIndex="0"
            :initialSelectedSmdIndex="1"
          />
        </div>
        <div class="col-xs-6">
          <span class="info caution">{{ selected.md2 }}</span>
          <div class="comm_line_div" />
          <span class="info caution">{{ selected.smd2 }}</span>
        </div>
      </div>

      <hr>

      <div class="row">
        <div class="col-xs-2">
          <sui-input-label label="<code-select> select" />
        </div>
        <div class="col-xs-4">
          <sui-code-select
            :selected="selected.code"
            :defaultOption="'select'"
            codeId="COD_PAGE_TYPE"
            :pageId="this.$options.name"
            @list-clicked="onListClicked"
          />
        </div>
        <div class="col-xs-6">
          <span class="info caution">{{ selected.code }}</span>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-2">
          <sui-input-label label="<code-select> all" />
        </div>
        <div class="col-xs-4">
          <sui-code-select
            :selected="selected.code2"
            :defaultOption="'all'"
            codeId="COD_PAGE_TYPE"
            :pageId="this.$options.name"
          />
        </div>
        <div class="col-xs-6">
          <span class="info caution">{{ selected.code2 }}</span>
        </div>
      </div>

      <hr>

      <div class="row">
        <div class="col-xs-2">
          <sui-input-label label="<sui-lang-select>" />
        </div>
        <div class="col-xs-4">
          <sui-lang-select
            :selected="selected.lang"
            :pageId="this.$options.name"
            :defaultOption="'all'"
            :customOpitonList="customOptions"
          />
        </div>
        <div class="col-xs-6">
          <span class="info caution">{{ selected.lang }}</span>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-2">
          <sui-input-label label="<sui-yn-select>" />
        </div>
        <div class="col-xs-4">
          <sui-yn-select
            :selected="selected.yn"
            :defaultOption="'select'"
          />
        </div>
        <div class="col-xs-6">
          <span class="info caution">{{ selected.yn }}</span>
        </div>
      </div>

      <hr>

      <div class="row">
        <div class="col-xs-2">
          <sui-input-label label="<sui-custom-select> (1)" />
        </div>
        <div class="col-xs-4">
          <sui-custom-select
            :selected="selected.custom"
            :initialSelectedIndex="1"
            :option-list="customOptions"
          />
        </div>
        <div class="col-xs-6">
          <span class="info caution">{{ selected.custom }}</span>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-2">
          <sui-input-label label="<sui-custom-select>" />
        </div>
        <div class="col-xs-4">
          <sui-custom-select
            :selected="selected.custom2"
            :option-list="customOptions2"
          />
        </div>
        <div class="col-xs-6">
          <span class="info caution">{{ selected.custom2 }}</span>
        </div>
      </div>
      <div class="comm_btnBot_wrap">
        <div class="btn_wrapL">
          <button
            type="button"
            class="comm_btn_Scr"
            @click="onClick"
          >
            &lt;custom-select&gt; (1) 의 옵션리스트 변경
          </button>
        </div>
      </div>

      <!-- Multi Select -->
      <div class="comm_ptitle_wrap">
        <h1>Multi Select (above)</h1>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-2">
            <sui-label label="<multi-select>" />
          </div>
          <div class="col-xs-4">
            <multi-select
              ref="multiSelect2"
              v-model="multiSelectValue"
              :options="multiSelectOptions"
              :multiple="true"
              :closeOnSelect="false"
              :useAllOption="true"
              @select="onAfterSelecting"
              @confirm="onConfirm"
            />
          </div>
          <div class="col-xs-6">
            <div class="info">
              multi
            </div>
            <div class="comm_line_div" />
            <span class="info caution">{{ multiSelectValue }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-2">
            <sui-label label="<multi-select>" />
          </div>
          <div class="col-xs-4">
            <multi-select
              ref="multiSelect3"
              v-model="multiSelectValue"
              :options="multiSelectOptions"
              @select="onAfterSelecting"
            />
          </div>
          <div class="col-xs-6">
            <div class="info">
              single
            </div>
            <div class="comm_line_div" />
            <span class="info caution">{{ multiSelectValue }}</span>
          </div>
        </div>
      </div>
    </sui-page-contents>
  </sui-page>
</template>
<script>

export default {
  name: 'PGE_FLW_00007', // eslint-disable-line vue/name-property-casing
  data() {
    return {
      selected: {
        md: {
          key: '',
          label: '',
        },
        md2: {
          key: '',
          label: '',
        },
        smd: {
          key: '',
          label: '',
        },
        smd2: {
          key: '',
          label: '',
        },
        code: {
          key: '',
          label: '',
        },
        code2: {
          key: '',
          label: '',
        },
        lang: {
          key: '',
          label: '',
        },
        yn: {
          key: '',
          label: '',
        },
        custom: {
          key: null,
          label: '',
        },
        custom2: {
          key: 'D',
          label: '',
        },
        customlang: {
          key: '',
          label: '',
        },
      },
      customOptions: [{
        key: 'D',
        label: '개발',
      },
      {
        key: 'F',
        label: '완료',
      },
      ],
      customOptions2: [{
        key: 'D',
        label: '개발',
      },
      {
        key: 'F',
        label: '완료',
      },
      ],

      // for multi-select
      multiSelectValue: [],
      multiSelectOptions: [
        {
          key: 'm1',
          label: 'aulti1',
        },
        {
          key: 'm2',
          label: 'bulti2',
        },
        {
          key: 'm3',
          label: 'culti3',
        },
        {
          key: 'm4',
          label: 'dulti4',
        },
        {
          key: 'm5',
          label: 'eulti5',
        },
        {
          key: 'm10',
          label: 'happy10',
        },
        {
          key: 'm6',
          label: 'happy16',
        },
        {
          key: 'm7',
          label: 'happy17kdsjfak;ljsdk;lfjkl;wejk;hk;ajdkl;f',
        },
        {
          key: 'm8',
          label: 'happy1884df45s6a4df56erhjakhjkldghasjkld',
        },
        {
          key: 'm9',
          label: 'happy19sdkfjkljeqriotujk;dlsjfk;ljsddk;fjak;djk;lgjask;ldjklh;gajskl;djhkl;jsdkl;jhakl;sdjhkl;ajdkl;fjl;kwejkhhafjsdfkㅇ한국어되나.안되나', // eslint-disable-line max-len
        },
      ],

      // for order-select
      orderSelectSelectedItem: {
        key: '',
        label: '',
      },
      orderSelectOptionList: [
        {
          key: 'A001',
          order: '1차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          status: '진행중',
        },
        {
          key: 'A002',
          order: '2차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          status: '미진행',
        },
        {
          key: 'A003',
          order: '3차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          status: '재요청',
        },
        {
          key: 'A004',
          order: '4차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          status: '완료',
        },
        {
          key: 'A005',
          order: '5차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          status: '완료',
        },
        {
          key: 'A006',
          order: '6차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          status: '완료',
        },
        {
          key: 'A007',
          order: '7차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          status: '완료',
        },
        {
          key: 'A008',
          order: '8차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          status: '미진행',
        },
        {
          key: 'A009',
          order: '999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          status: '완료',
        },
        {
          key: 'A010',
          order: '4545555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          status: '완료',
        },
        {
          key: 'A011',
          order: '33333333333333333333333333차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          status: '완료',
        },
        {
          key: 'A012',
          order: '33333333333333333333333333차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          status: '완료',
        },
        {
          key: 'A013',
          order: '33333333333333333333333333차',
          startDate: '2019-03-01',
          endDate: '2019-06-05',
          status: '완료',
        },
      ],
    };
  },
  mounted() {
    this.customOptions2 = [{
      key: 'D',
      label: 'New개발',
    },
    {
      key: 'F',
      label: 'New완료',
    },
    {
      key: 'A',
      label: '긴거 샘플1',
    },
    {
      key: 'B',
      label: '긴거 샘플2',
    },
    {
      key: 'C',
      label: '긴거 샘플3',
    },
    {
      key: 'E',
      label: '긴거 샘플4',
    },
    {
      key: 'G',
      label: '긴거 샘플5',
    },
    {
      key: 'H',
      label: '긴거 샘플6',
    },
    {
      key: 'I',
      label: '긴거 샘플7',
    },
    {
      key: 'J',
      label: '긴거 샘플8',
    },
    {
      key: 'K',
      label: '긴거 샘플9',
    },
    {
      key: 'L',
      label: '긴거 샘플10',
    },
    {
      key: 'M',
      label: '긴거 샘플11',
    },
    {
      key: 'N',
      label: '긴거 샘플12',
    },
    {
      key: 'O',
      label: '긴거 샘플13',
    },
    {
      key: 'P',
      label: '긴거 샘플14',
    },
    {
      key: 'Q',
      label: '긴거 샘플15',
    },
    {
      key: 'R',
      label: '긴거 샘플16',
    },
    {
      key: 'S',
      label: '긴거 샘플17',
    },
    ];
  },
  methods: {
    onClick() {
      this.customOptions = [{
        key: 'a',
        label: 'a',
      },
      {
        key: 'b',
        label: 'b',
      },
      {
        key: 'c',
        label: 'c',
      },
      ];
      this.selected.custom.key = 'b';
    },

    // <code-select> @list-clicked
    onListClicked(event, item) {
      console.log(event, item);
    },

    // <multi-select> @confirm
    // when confirm clicked.
    onConfirm(selectedItem) {
      console.log(`[Sample] MultiSelect.onConfirm() : selectedItem = ${JSON.stringify(selectedItem)}`);
    },

    // <multi-select> @select
    // Emitted after selecting an option.
    onAfterSelecting(selectedItem, id) {
      console.log(`[Sample] MultiSelect.onAfterSelecting() : selectedItem = ${
        JSON.stringify(selectedItem)
      }, id = ${id}`);
    },

    // <cmp-order-select> @list-click
    onClickOrderSelectItem(item) {
      console.log('[Samples] <cmp-order-select> @list-click (item)', JSON.stringify(item));
      console.log('[Samples] <cmp-order-select> @list-click (v-model)', JSON.stringify(this.orderSelectSelectedItem));
    },
  },
};
</script>
